// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminContainer_container__j6l2E"};